/**
 * mc library
 */

import µ from "../../earth/1.0.0/micro";
import * as THREE from "three";

export default (function(scene, radius) {

    var SEGMENTS = 180; // number of vertices. Higher = better mouse accuracy, slower loading
    var TRANSPARENT_BLACK = [0, 0, 0, 0];     // singleton 0 rgba
    var OVERLAY_ALPHA = Math.floor(0.5*255);  // overlay transparency (on scale [0, 255])

    var overlayGeometry;
    var overlayMaterial, overlayMesh, overlayTexture, overlayTextureData;
    var spaceMesh;
    const overlayMeshName = "earthImageOverlayMesh";
    const spaceMeshName = "spaceMesh";


    function makeOverlayTexture(grids) {
        overlayTexture = new THREE.Texture();
        overlayTexture.minFilter = THREE.LinearFilter;
        overlayTexture.magFilter = THREE.LinearFilter;
    }

    function meshOverlayMaterial(grids, quickRender) {

        //22.08.01 by shson :심성보 연구사 요청으로 움직이는 우주배경기능 추가,
        var spaceGeo = new THREE.SphereGeometry(1500, 50, 50);
        const loader  = new THREE.TextureLoader();
        const texture = loader.load( "space15.jpeg" );
        const material = new THREE.MeshBasicMaterial({
            map: texture,
        });
        spaceMesh = new THREE.Mesh(spaceGeo, material);
        spaceMesh.material.side = THREE.BackSide;
        spaceMesh.name = spaceMeshName;

        scene.add(spaceMesh);


        overlayGeometry = new THREE.SphereBufferGeometry(radius, SEGMENTS, SEGMENTS);
        overlayMaterial = new THREE.MeshBasicMaterial({
            transparent: true,
            wireframe: false,
            opacity: 1,
        });


        // overlayMaterial.map = overlayTexture;
        overlayMaterial.map = new THREE.TextureLoader().load('earth.jpg')
        overlayMesh = new THREE.Mesh(overlayGeometry, overlayMaterial);
        overlayMesh.name = overlayMeshName;

        scene.add(overlayMesh);



        quickRender();
    }


    function updateOverlayTexture(grids, quickRender, worldMapImage) {
        // if(!overlayTextureData || !overlayTexture) return;
        overlayMaterial.map = new THREE.TextureLoader().load('earth.jpg')
    }


    function clear(){
        if(overlayTexture) overlayTexture.dispose();
        if(overlayGeometry) overlayGeometry.dispose();
        if(overlayMaterial) {
            overlayMaterial.map.dispose();
            overlayMaterial.dispose();
        }

        if(overlayMesh) scene.remove(scene.getObjectByName(overlayMeshName));
        if(spaceMesh) scene.remove(scene.getObjectByName(spaceMeshName));

        overlayTexture = undefined;
        overlayGeometry = undefined;
        overlayMaterial = undefined;
        overlayMesh = undefined;
        spaceMesh = undefined;
        overlayTextureData = undefined;
    }

    function moveOverlay(rotate, scale) {
        if (overlayMesh) {
            // roate
            var twoPI = Math.PI * 2;
            var halfPI = Math.PI / 2;
            overlayMesh.rotation.y = Math.PI + halfPI + (rotate[0] / 360 * twoPI) + (-0.35 * Math.PI / 180);
            overlayMesh.rotation.x = -rotate[1] / 90 * Math.PI / 2;
            overlayMesh.rotation.z = rotate[2] / 360 * twoPI;

            // zoom
            overlayMesh.scale.set(scale, scale, scale);
        }

        if (spaceMesh) {
            // roate
            var twoPI = Math.PI * 2;
            var halfPI = Math.PI / 2;
            spaceMesh.rotation.y = Math.PI + halfPI + (rotate[0] / 360 * twoPI) + (-0.35 * Math.PI / 180);
            spaceMesh.rotation.x = -rotate[1] / 90 * Math.PI / 2;
            spaceMesh.rotation.z = rotate[2] / 360 * twoPI;
        }
    }

    return {
        render: function render(grids, quickRender){

            // let overlayGrid = grids.overlayGrid;
            // let header = overlayGrid.header;
            // if(header === "") {
            //     clear();
            //     quickRender();
            //     return;
            // };

            clear();
            // makeOverlayTexture(grids);
            meshOverlayMaterial(grids, quickRender);
            // updateOverlayTexture(grids, quickRender);
        },
        clear: clear,
        moveOverlay,
    };
});
